import { OwcTabs, OwcTab } from '@one/react';

/**
 * Generic, controlled tab group built on OwcTabs/OwcTab.
 *
 * Presentational: the parent owns `active` and handles `onChange`.
 *
 * @param {object} props
 * @param {Array<{ key: string, label: React.ReactNode }>} props.tabs
 * @param {string} props.active                    currently selected key (tab value)
 * @param {(key: string) => void} props.onChange
 * @param {string} [props.ariaLabel='Filter']
 * @param {string} [props.className]
 */
export default function Tabs({
  tabs = [],
  active,
  onChange,
  ariaLabel = 'Filter',
  className = '',
}) {
  return (
    <OwcTabs
      value={active}
      aria-label={ariaLabel}
      className={className}
      onValueChange={(e) => onChange?.(e.detail)}
    >
      {tabs.map((tab) => (
        <OwcTab key={tab.key} value={tab.key}>
          {tab.label}
        </OwcTab>
      ))}
    </OwcTabs>
  );
}
